import React, { useEffect, useState, useRef } from "react"
import axios from 'axios'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPrint, faTrashAlt, faSignOutAlt, faFileExcel } from "@fortawesome/free-solid-svg-icons"
import { sha256 } from 'js-sha256'
import Header from "./components/header"
import Etiquette from "./components/etiquette"
import moment from 'moment'
import ReactExport from "react-export-excel"
import Loader from "react-loader-spinner"

export const Sortie = () => {

  const hash = sha256(process.env.REACT_APP_HMSG)
  const [reload, setReload] = useState(true)
  const [loading, setLoading] = useState(false)
  const [displayButton, setDisplayButton] = useState(false)
  const metrageRef = useRef()
  const qrcodeRef = useRef()

  const ExcelFile = ReactExport.ExcelFile
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

  /* 821;550;099992002;0;0;144;195;1;1205;03/07/2021;V1 */

  const [base, setBase] = useState({
    exports: [],
    list: [],
  })

  const [infoOutStock, setInfoOutStock] = useState({
    metrage: 0,
    idcarton: "",
    metragebase: 0,
    checkbox: false,
  })

  const [form, setForm] = useState({
    idcarton: 0,
    fournisseur: "",
    fournisseurLibelle: "",
    famille: "",
    couleur: "",
    casier: "",
    idbaguette: "",
    longueur: 0,
    nombre: 0,
    metrage: 0,
    date: moment(new Date()).format('DD/MM/Y'),
  })

  useEffect(() => {
    if (typeof window !== "undefined" && reload) {
      setReload(false)
      axios.get(`${process.env.REACT_APP_API_URL}/stock/export?talk=${hash}`)
        .then(({ data }) => {
          setBase({
            ...base,
            exports: data.exports,
            list: data.exports
          })
        })
        .catch(function (error) {
          console.log(error)
          alert("Erreur de communication avec la base !")
        })
      qrcodeRef.current.focus()
    }
  }, [base, hash, reload])


  const handlePrint = (car_id) => {
    let exports = base.exports.find(b => b.car_id === car_id)
    setForm({
      ...form,
      idcarton: exports.car_id,
      fournisseur: exports.ba_ref_fournisseur,
      fournisseurLibelle: exports.fo_libelle,
      famille: exports.ba_fk_id_famille,
      familleLibelle: exports.fa_libelle,
      couleur: exports.ba_fk_id_couleur,
      couleurLibelle: exports.co_libelle,
      casier: exports.ba_fk_id_casier,
      casierLibelle: exports.ca_libelle,
      idbaguette: exports.car_idbaguette,
      longueur: exports.car_longbaguette,
      nombre: exports.car_nbbaguette,
      metrage: exports.car_metrage,
      date: exports.car_timestamp,
    })
    window.print()
  }

  const handleRemove = (car_id) => {
    if (parseInt(car_id) > 0) {
      axios.post(`${process.env.REACT_APP_API_URL}/stock/remove?talk=${hash}`, {
        idcarton: parseInt(car_id),
      })
        .then(function (response) {
          if (response.status === 200) {
            console.log("200");
            setReload(true)
          } else {
            console.log("400");
          }
        })
        .catch(function (error) {
          console.log(error)
        });
    }
  }

  const handleOut = (car_id, car_metrage) => {
    setInfoOutStock({
      ...infoOutStock,
      idcarton: car_id,
      metrage: car_metrage,
      metragebase: car_metrage,
      checkbox: true,
    })
    metrageRef.current.value = car_metrage
    qrcodeRef.current.value = car_id
    setDisplayButton(true)
    window.scrollTo(0, 0);
  }

  const handleUpdate = event => {
    if (event.target.name === "qrcode") {
      const str = event.target.value
      if (event.target.value === "") {
        setDisplayButton(false)
      }
      const words = str.split(";")
      if (words[10] !== undefined && words[10] === "V1") {
        let metrageExport = base.exports.find(f => f.car_id === parseInt(words[0])).car_metrage
        setInfoOutStock({
          ...infoOutStock,
          idcarton: words[0],
          metrage: metrageExport,
          metragebase: metrageExport,
        })
        metrageRef.current.value = metrageExport
        metrageRef.current.focus()
        if (parseInt(words[0]) > 0 && parseInt(words[5]) !== 0 && !infoOutStock.checkbox) {
          outStock(parseInt(words[0]), parseInt(words[5]))
        } else if (parseInt(words[0]) > 0 && parseInt(words[5]) !== 0 && infoOutStock.checkbox) {
          setDisplayButton(true)
        }
      }
    } else if (event.target.name === "checkbox") {
      setInfoOutStock({ ...infoOutStock, checkbox: event.target.checked })
    } else {
      setInfoOutStock({ ...infoOutStock, [event.target.name]: event.target.value })
    }
  }

  const outStock = (idcartonArg = null, metrageArg = null) => {
    let theIdcarton = idcartonArg === null ? infoOutStock.idcarton : idcartonArg
    let theMetrage = metrageArg === null ? infoOutStock.metrage : metrageArg
    let theMetrageBase = metrageArg === null ? infoOutStock.metragebase : metrageArg
    if (parseInt(theIdcarton) > 0 && parseInt(theMetrage) !== 0) {
      setLoading(true)
      axios.post(`${process.env.REACT_APP_API_URL}/stock/outStock?talk=${hash}`, {
        idcarton: parseInt(theIdcarton),
        metrage: parseInt(theMetrage),
        diff: parseInt(theMetrage) !== parseInt(theMetrageBase),
      })
        .then(function (response) {
          if (response.status === 200) {
            setDisplayButton(false)
            setReload(true)
            metrageRef.current.value = 0
            qrcodeRef.current.value = ""
            setInfoOutStock({
              ...infoOutStock,
              idcarton: "",
              metrage: 0,
              metragebase: 0,
            })
          } else {
            console.log("400");
          }
        })
        .catch(function (error) {
          console.log(error)
        });
      setLoading(false)
    }
  }

  const handleSearch = event => {
    if (event.target.name === "search") {
      const search = event.target.value
      const fileteredResults = base.exports.filter(f => f.ca_libelle.indexOf(search) >= 0)

      if (fileteredResults.length > 0) {
        setBase({
          ...base, list: fileteredResults
        })
      } else if (search === undefined) {
        setBase({
          ...base, list: base.exports
        })
      } else if (fileteredResults.length === 0) {
        setBase({
          ...base, list: []
        })
      }
    }
  }

  return (
    <>
      <Header />
      <div className="noprint">
        <div className="hero pattern-zigzag-light" style={{ marginTop: -4 }}>
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="title is-2 has-text-centered">Sortie</h1>
            </div>
          </div>
        </div>
        <div className="container is-fluid pb-5">
          <div className="columns is-centered">
            <div className="column couleurShadow">
              <div className="box">
                <h2 className="is-size-4 mb-4" style={{ color: "#7e421e", paddingBottom: 5, borderBottom: "1px solid #ccc" }}>Scanner le QR Code</h2>
                <form>
                  <label className="checkbox">
                    <input type="checkbox" id="checkbox" checked={infoOutStock.checkbox} name="checkbox" onChange={e => handleUpdate(e)} className="mr-2" />
                    Modifier la quantité de sortie
                  </label>
                  <div className="columns">
                    <div className="column">
                      <div className="field ">
                        <label className="label" htmlFor="qrcode">
                          &nbsp;
                        </label>
                        <div className="control">
                          <input type="text" required id="qrcode" name="qrcode" ref={qrcodeRef} onChange={e => handleUpdate(e)} className="input" placeholder="Scannez QR Code" autoComplete="off" />
                        </div>
                      </div>
                    </div>
                    <div className="column">
                      <div className="field">
                        <label className="label" htmlFor="metrage">
                          Longueur à sortir&nbsp;:
                        </label>
                        <div className="control">
                          <input type="number" id="metrage" name="metrage" step="1" disabled={!infoOutStock.checkbox} onChange={e => handleUpdate(e)} required ref={metrageRef} className="input" placeholder="Longueur à sortir" min="1" max={infoOutStock.metragebase} autoComplete="off" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="columns" style={{ paddingTop: "30px" }}>
                    <div className="column field has-text-centered" >
                      <button type="button" onClick={event => outStock()} className={`button is-link is-light is-medium ${loading ? `is-loading` : ``} ${displayButton ? `` : `is-hidden`} `} >
                        <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" /> Sortir du stock
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="container is-fluid pb-5">
          <div className="columns is-centered">
            <div className="column">
              <div className="box">
                <h2 className="is-size-4 mb-4" style={{ color: "#7e421e", paddingBottom: 5, borderBottom: "1px solid #ccc" }}>Liste</h2>
                <div className="columns">
                  <div className="column is-one-fifth">
                    <div className="field">
                      <div className="control">
                        <input type="text" id="search" name="search" onKeyUp={e => handleSearch(e)} className="input" placeholder="Rechercher par n° casier" autoComplete="off" />
                      </div>
                    </div>
                  </div>
                  <div className="column has-text-right">
                    <ExcelFile filename={`ExportCarton_${moment(new Date()).format('DD/MM/Y_HH_mm')}`} element={<button className="button is-success is-light is-small" ><FontAwesomeIcon icon={faFileExcel} className="mr-2" />Export Excel</button>}>
                      <ExcelSheet data={base.exports} name="Carton" >
                        <ExcelColumn label="Fournisseur" value="fo_libelle" />
                        <ExcelColumn label="Ref. fournisseur" value="ba_ref_fournisseur" />
                        <ExcelColumn label="Métrage" value="car_metrage" />
                        <ExcelColumn label="Casier" value="ca_libelle" />
                        <ExcelColumn label="Date" value="car_timestamp" />
                        <ExcelColumn label="Id carton" value="car_id" />
                        <ExcelColumn label="Prix d'achat" value="ba_prix" />
                      </ExcelSheet>
                    </ExcelFile>
                  </div>
                </div>
                <Loader
                  type="Rings"
                  color="#3e8ed0"
                  height={100}
                  width={100}
                  className={`center-div ${base.exports.length === 0 ? `` : `is-hidden`} `}
                />
                <table className={`table is-striped is-fullwidth ${base.exports.length === 0 ? `is-hidden` : ``} `}>
                  <thead>
                    <tr>
                      <th>Fournisseur</th>
                      <th>Réf. fournisseur</th>
                      <th className="has-text-centered">Métrage</th>
                      <th className="has-text-centered">Casier</th>
                      <th className="has-text-centered">Date</th>
                      <th className="has-text-centered">Numéro Carton</th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {base.list.sort((a, b) => parseInt(b.car_id) - parseInt(a.car_id)).map(ca => (
                      <tr key={ca.car_id}>
                        <td>{ca.fo_libelle}</td>
                        <td>{ca.ba_ref_fournisseur}</td>
                        <td className="has-text-centered">{ca.car_metrage}</td>
                        <td className="has-text-centered">{ca.ca_libelle}</td>
                        <td className="has-text-centered">{ca.car_timestamp}</td>
                        <td className="has-text-centered">{ca.car_id}</td>
                        <td className="has-text-centered"><button id={`out-${ca.car_id}`} title="Déstocker" onClick={() => handleOut(ca.car_id, ca.car_metrage)} className={`nobutton`} >
                          <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                        </button>
                        </td>
                        <td className="has-text-centered"><button id={`print-${ca.car_id}`} title="Réimprimer" onClick={() => handlePrint(ca.car_id)} className={`nobutton`} >
                          <FontAwesomeIcon icon={faPrint} className="mr-2" />
                        </button>
                        </td>
                        <td className="has-text-centered"><button id={`remove-${ca.car_id}`} title="Supprimer définitivement" onClick={() => handleRemove(ca.car_id)} className={`nobutton`} >
                          <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                        </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div >
        <Etiquette idcarton={form.idcarton} idbaguette={form.idbaguette} fournisseur={form.fournisseur} nombre={form.nombre} longueur={form.longueur} metrage={form.metrage} famille={form.famille} couleur={form.couleur} casier={form.casier} fournisseurLibelle={form.fournisseurLibelle} familleLibelle={(form.familleLibelle)} couleurLibelle={(form.couleurLibelle)} casierLibelle={(form.casierLibelle)} date={form.date} />
      </div>
    </>
  )
}

export default Sortie
